import { Button } from "@mui/material";
import React from "react";
import { useDispatch } from "react-redux";
import { openShipmentItemsCreatePopup } from "./shipmentItemsSlice";
import { useTranslation } from "react-i18next";

const AddShipmentItemButton = ({boxID}) => {
    const {t} = useTranslation()
    const dispatch = useDispatch()
    
    const handleButtonClick = () => {
        if(!boxID) {
            return
        }

        dispatch(openShipmentItemsCreatePopup({
            boxID: boxID
        }))
    }

    return (
        <Button
            variant="contained"
            sx={{
                color: "white",
                bgcolor: "#059669",
                fontSize: "0.7rem",
                ":hover": {
                    bgcolor: "#047857",
                },
                ":focus": {
                    bgcolor: "#047857",
                },
            }}
            onClick={handleButtonClick}
            style={{padding: "3px 6px"}}
        >
            
            {t("shipment.items.add_item_button")}
        </Button>
    );
};

export default AddShipmentItemButton;
